"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceParticipant = void 0;
/**
 * Invoice containing collected ChargeItems from an Account with calculated individual and total price for Billing purpose.
 */
var InvoiceParticipant = /** @class */ (function () {
    function InvoiceParticipant() {
    }
    return InvoiceParticipant;
}());
exports.InvoiceParticipant = InvoiceParticipant;
